import OrganizationDetailSidebar from './OrganizationDetailSidebar';

export default OrganizationDetailSidebar;
